<template>
  <div class="container">
    <a class="link" @click="handleClick('https://www.sfbuy.com/cms/helper?key=1002')">{{ $t('sfbuy.aboutUs') }}</a>
    <div class="divider" />
    <a class="link" @click="handleClick('https://www.sfbuy.com/cms/helper?key=1008')">{{ $t('sfbuy.serviceGuide') }}</a>
    <div class="divider" />
    <a class="link" @click="handleClick('http://www.sfbuy.com/new/helper/toProblem')">{{ $t('sfbuy.helpCenter') }}</a>
    <div class="divider" />
    <a class="link" @click="handleClick('https://www.sfbuy.com/service?type=1')">{{ $t('sfbuy.serviceAndPrice') }}</a>
  </div>
</template>

<script>
export default {
  name: 'SFBuyCopyRight',
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 100vw;
}

.link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin: 0 20px;
  color: #666666;
  text-decoration: none;
  cursor: pointer;
}

.divider {
  height: 20px;
  width: 1px;
  background-color: #666666;
}
</style>
